import { useEventsConnectionState } from '../../hooks/chat/useChatEvents';

const STRIP_COPY: Partial<Record<string, string>> = {
  polling: 'Live updates paused. Checking every 30 seconds.',
  stopped: 'You are offline. Messages will load when you reconnect.',
};

/**
 * The live-updates strip. Each view renders it right under its own header,
 * because the views own their headers (spec, Live updates).
 */
export function ConnectionStrip() {
  const strip = STRIP_COPY[useEventsConnectionState()];
  if (!strip) return null;
  return (
    <p className='bg-muted px-3 py-1 text-[11px] text-muted-foreground'>
      {strip}
    </p>
  );
}
